module.exports = __webpack_public_path__ + "img/j.ce055f59.jpg";